import type { SVGProps } from 'react';

export function SvgLinkedin(props: SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      {...props}
      fill="none"
      height="1em"
      viewBox="0 0 25 25"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.926 5.902A2.914 2.914 0 0 0 5.83 2.979 2.914 2.914 0 0 0 2.91.07 2.914 2.914 0 0 0 .007 2.994a2.914 2.914 0 0 0 2.92 2.908Zm5.584 2.14 4.825-.012.006 2.213s1.303-2.625 4.866-2.634c3.178-.008 5.815 1.553 5.827 6.331l.026 10.077-5.001.013-.023-8.856c-.007-2.819-1.51-3.125-2.656-3.122-2.377.006-2.778 2.06-2.775 3.504l.022 8.488-5.077.012zm-8.117.021 5.076-.013.04 16.014-5.076.013z"
        fill="currentColor"
      />
    </svg>
  );
}
